/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { compare, generate } from 'fast-json-patch';

import type { Operation } from 'fast-json-patch';

import type { RequestPatchComparedData, RequestPatchGeneratedData, TransportPatchData } from '../interfaces';

export * as FastJsonPatch from 'fast-json-patch';

export const prepareJsonPatchData = <T>(data: TransportPatchData<T>): Operation[] => {
    if ((data as RequestPatchComparedData<T>).original) {
        const { original, current, invertible } = data as RequestPatchComparedData<T>;

        return compare(original, current, invertible);
    } else if ((data as RequestPatchGeneratedData<T>).observer) {
        const { observer, invertible } = data as RequestPatchGeneratedData<T>;

        return generate(observer, invertible);
    }

    return [];
};
